import { categoriasPet } from '../../helpers/funcoesAuxiliares';
import { verificarExcecaoPetPorLocalidade } from '../validadoresComunsPorPlano/excecoes';
import {
    validatorDependenteSemValorAdicional,
    validatorAte64Anos,
    validatorMaior79Anos,
    validatorPaiMaior79Anos,
    validatorMadrastaMaior79,
    validatorConjugeMaior79Anos,
    validatorMaiorIgual65Anos,
    validatorExConjugeMaior79,
    validatorSomenteEsposoSemExConjuge,
    validatorSomenteMaeSemMadrasta,
    validatorExConjugeAte64,
    validatorExConjugeMaiorIgual65,
    validatorMadrastaAte64,
    validatorMadrastaMaiorIgual65,
    validatorPadrastoMaiorIgual65,
    validatorPadrastoAte64,
    validatorPadrastoMaior79,
    validatorConjugeAte64Anos,
    validatorConjugeMaiorIgual65Anos,
    validatorMaeAte64Anos,
    validatorMaeMaior79Anos,
    validatorMaeMaiorIgual65Anos,
    validatorPaiAte64Anos,
    validatorPaiMaiorIgual65Anos,
    validatorSomentePaiSemPadrasto,
    validatorDependentesQuePodemSemOuComAdicionalAte64,
    validatorDependentesQuePodemSemOuComAdicionalMaior79,
    validatorDependentesQuePodemSemOuComAdicionalMaiorIgual65,
    validatorParentescoEmDuplicidadeCadastro,
    retornaLabelDoValorParentesco
} from './funcoesAuxiliaresZE';

export class CorrenteCadastroZE {
    constructor(dependentes, parentesco, categorias, valoresForm, isValid) {
        this.dependentes = dependentes;
        this.parentesco = parentesco;
        this.categorias = categorias;
        this.arrayMsgsErro = [];
        this.valoresForm = valoresForm;
        this.isValid = isValid;
        this.categoriaSelecionada = valoresForm.Categoria;
        this.possuiDependendenteTipoEsposo = this.verificarPossuiDependenteTipoEsposo();
        this.possuiDependenteTipoExConjuge = this.verificarPossuiDependenteTipoExConjuge();
        this.possuiDependendenteTipoMae = this.verificarPossuiDependenteTipoMae();
        this.possuiDependenteTipoMadrasta = this.verificarPossuiDependenteTipoMadrasta();
        this.maximoDependentesPet = 1;
    }

    verificarPossuiDependenteTipoEsposo() {
        const dependenteTipoEsposo = this.dependentes.find(dependente => dependente.Parentesco === 'ESPOSO(A)');

        return dependenteTipoEsposo;
    }

    verificarPossuiDependenteTipoExConjuge() {
        const dependentetipoExConjuge = this.dependentes.find(dependente => dependente.Parentesco === 'EX-CONJUGE');

        return dependentetipoExConjuge;
    }

    verificarPossuiDependenteTipoMae() {
        const dependenteTipoMae = this.dependentes.find(dependente => dependente.Parentesco === 'MAE');

        return dependenteTipoMae;
    }

    verificarPossuiDependenteTipoMadrasta() {
        const dependenteTipoMadrasta = this.dependentes.find(dependente => dependente.Parentesco === 'MADRASTA');

        return dependenteTipoMadrasta;
    }

    possui14Dependentes() {
        const qtdDependentesTotais = this.dependentes.length;

        if (qtdDependentesTotais === 14) {
            this.arrayMsgsErro.push('Este plano permite apenas 14 dependentes.');
        }

        return this;
    }

    infringeParentescoSemAdicional() {
        if (validatorDependenteSemValorAdicional(this.valoresForm)) {
            this.arrayMsgsErro.push('Dependentes do tipo Pais, Filhos, Cônjuge, Sogro (a), Enteados e Adotivos só podem ser inseridos SEM VALOR ADICIONAL.');
        }

        return this;
    }

    permitirSomenteConjugeSemValorAdicional() {
        if (validatorSomenteEsposoSemExConjuge(this.valoresForm, this.dependentes)) {
            this.arrayMsgsErro.push('Só são permitidos conjuges com valor adicional caso exista um Ex-conjuge sem valor adicional cadastrado.');
        }

        return this;
    }

    permitirSomenteMaeSemValorAdicional() {
        if (validatorSomenteMaeSemMadrasta(this.valoresForm, this.dependentes)) {
            this.arrayMsgsErro.push('Só é permitido parentesco do tipo Mãe com valor adicional caso exista uma Madrasta sem valor adicional cadastrada.');
        }

        return this;
    }

    permitirSomentePaiSemValorAdicional() {
        if (validatorSomentePaiSemPadrasto(this.valoresForm, this.dependentes)) {
            this.arrayMsgsErro.push('Só é permitido parentesco do tipo Pai com valor adicional caso exista um Padrasto sem valor adicional cadastrado.');
        }

        return this;
    }

    parentescoComAdicionalAte64() {
        const parentescoTipoExConjuge = '32';

        if (validatorAte64Anos(this.valoresForm) && this.valoresForm.Parentesco !== parentescoTipoExConjuge && this.valoresForm.Parentesco !== '10' && this.valoresForm.Parentesco !== '02') {
            this.arrayMsgsErro.push('Para dependentes do tipo Irmã (o), Sobrinho (a), Outros, Neto (a), Primo (a), Tio (a), Avo e Pet (animal) até 64 anos, o adicional permitido é o ZELO ATÉ 64 ANOS.');
        }

        return this;
    }

    parentescoComAdicionalMaiorIgual65() {
        const parentescoTipoExConjuge = '32';

        if (validatorMaiorIgual65Anos(this.valoresForm) && this.valoresForm.Parentesco !== parentescoTipoExConjuge) {
            this.arrayMsgsErro.push('Para dependentes do tipo Irmã (o), Sobrinho (a), Outros, Neto (a), Primo (a), Tio (a), Avo e Pet (animal) acima de 65 anos, o adicional permitido é o ZELO MAIOR 65 ANOS.');
        }

        return this;
    }

    parentescoComAdicionalMaior79() {
        const parentescoTipoExConjuge = '32';

        if (validatorMaior79Anos(this.valoresForm) && this.valoresForm.Parentesco !== parentescoTipoExConjuge) {
            this.arrayMsgsErro.push('Para dependentes do tipo Irmã (o), Sobrinho (a), Outros, Neto (a), Primo (a), Tio (a), Avo e Pet (animal) acima de 79 anos, o adicional permitido é o ZELO MAIOR 79 ANOS.');
        }

        return this;
    }

    conjugeMaiorComAdicionalMaior79() {
        if (validatorConjugeMaior79Anos(this.valoresForm, this.dependentes)) {
            this.arrayMsgsErro.push('Caso já exista um dependente do tipo Ex-Conjuge e queira adicionar um dependente do tipo Esposo(A) acima de 79 anos é necessário o adicional ZELO MAIOR 79 ANOS.');
        }

        return this;
    }

    conjugeComAdicionalAte64() {
        if (validatorConjugeAte64Anos(this.valoresForm, this.dependentes)) {
            this.arrayMsgsErro.push('Caso já exista um dependente do tipo Ex-Conjuge e queira adicionar um dependente do tipo Esposo(A) até 64 anos é necessário o adicional ZELO ATÉ 64 ANOS.');
        }

        return this;
    }

    conjugeComAdicionalMaiorIgual65() {
        if (validatorConjugeMaiorIgual65Anos(this.valoresForm, this.dependentes)) {
            this.arrayMsgsErro.push('Caso já exista um dependente do tipo Ex-Conjuge e queira adicionar um dependente do tipo Esposo(A) acima de 65 anos é necessário o adicional ZELO MAIOR 65 ANOS.');
        }

        return this;
    }

    maeComAdicionalAte64() {
        if (validatorMaeAte64Anos(this.valoresForm, this.dependentes)) {
            this.arrayMsgsErro.push('Caso já exista um dependente do tipo Madrasta e queira adicionar um dependente do tipo Mãe até 64 anos é necessário o adicional ZELO ATÉ 64 ANOS.');
        }

        return this;
    }

    maeComAdicionalMaior79() {
        if (validatorMaeMaior79Anos(this.valoresForm, this.dependentes)) {
            this.arrayMsgsErro.push('Caso já exista um dependente do tipo Madrasta e queira adicionar um dependente do tipo Mãe maior que 79 anos é necessário o adicional ZELO ATÉ 79 ANOS.');
        }

        return this;
    }

    maeComAdicionalMaiorIgual65() {
        if (validatorMaeMaiorIgual65Anos(this.valoresForm, this.dependentes)) {
            this.arrayMsgsErro.push('Caso já exista um dependente do tipo Madrasta e queira adicionar um dependente do tipo Mãe acima de 65 anos é necessário o adicional ZELO MAIOR 65 ANOS.');
        }

        return this;
    }

    paiComAdicionalAte64() {
        if (validatorPaiAte64Anos(this.valoresForm, this.dependentes)) {
            this.arrayMsgsErro.push('Caso já exista um dependente do tipo Padrasto e queira adicionar um dependente do tipo Pai até 64 anos é necessário o adicional ZELO ATÉ 64 ANOS.');
        }

        return this;
    }

    paiComAdicionalMaiorIgual65() {
        if (validatorPaiMaiorIgual65Anos(this.valoresForm, this.dependentes)) {
            this.arrayMsgsErro.push('Caso já exista um dependente do tipo Padrasto e queira adicionar um dependente do tipo Pai acima de 65 anos é necessário o adicional ZELO MAIOR 65 ANOS.');
        }

        return this;
    }

    paiComAdicionalMaior79() {
        if (validatorPaiMaior79Anos(this.valoresForm, this.dependentes)) {
            this.arrayMsgsErro.push('Caso já exista um dependente do tipo Padrasto e queira adicionar um dependente do tipo Pai maior que 79 anos é necessário o adicional ZELO MAIOR 79 ANOS.');
        }

        return this;
    }

    exConjugeComAdicionalAte64() {
        if (validatorExConjugeAte64(this.valoresForm, this.dependentes)) {
            this.arrayMsgsErro.push('Caso já exista um dependente do tipo Esposo (a) ou EX-CONJUGE e queira adicionar um dependente do tipo Ex-conjuge até 64 anos é necessário o adicional ZELO ATÉ 64 ANOS.');
        }

        return this;
    }

    exConjugeComAdicionalMaior79() {
        if (validatorExConjugeMaior79(this.valoresForm, this.dependentes)) {
            this.arrayMsgsErro.push('Caso já exista um dependente do tipo Esposo (a) ou EX-CONJUGE e queira adicionar um dependente do tipo Ex-conjuge maior que 79 anos é necessário o adicional ZELO MAIOR 79 ANOS.');
        }

        return this;
    }

    exConjugeComAdicionalMaiorIgual65() {
        if (validatorExConjugeMaiorIgual65(this.valoresForm, this.dependentes)) {
            this.arrayMsgsErro.push('Caso já exista um dependente do tipo Esposo (a) ou EX-CONJUGE e queira adicionar um dependente do tipo Ex-conjuge acima de 65 anos é necessário o adicional ZELO MAIOR 65 ANOS.');
        }

        return this;
    }

    madrastaComAdicionalAte64() {
        if (validatorMadrastaAte64(this.valoresForm, this.dependentes)) {
            this.arrayMsgsErro.push('Caso já exista um dependente do tipo MÃE ou MADRASTA sem adicional e queira adicionar um dependente do tipo MADRASTA até 64 anos é necessário o adicional ZELO ATÉ 64 ANOS.');
        }

        return this;
    }

    madrastaComAdicionalMaior79() {
        if (validatorMadrastaMaior79(this.valoresForm, this.dependentes)) {
            this.arrayMsgsErro.push('Caso já exista um dependente do tipo MÃE ou MADRASTA sem adicional e queira adicionar um dependente do tipo MADRASTA maior que 79 anos é necessário o adicional ZELO MAIOR 79 ANOS.');
        }

        return this;
    }

    madrastaComAdicionalMaiorIgual65() {
        if (validatorMadrastaMaiorIgual65(this.valoresForm, this.dependentes)) {
            this.arrayMsgsErro.push('Caso já exista um dependente do tipo MÃE ou MADRASTA sem adicional e queira adicionar um dependente do tipo MADRASTA acima de 65 anos é necessário o adicional ZELO MAIOR 65 ANOS.');
        }

        return this;
    }

    padrastoComAdicionalAte64() {
        if (validatorPadrastoAte64(this.valoresForm, this.dependentes)) {
            this.arrayMsgsErro.push('Caso já exista um dependente do tipo PAI ou PADRASTO sem adicional e queira adicionar um dependente do tipo PADRASTO até 64 anos é necessário o adicional ZELO ATÉ 64 ANOS.');
        }

        return this;
    }

    padrastoComAdicionalMaior79() {
        if (validatorPadrastoMaior79(this.valoresForm, this.dependentes)) {
            this.arrayMsgsErro.push('Caso já exista um dependente do tipo PAI ou PADRASTO sem adicional e queira adicionar um dependente do tipo PADRASTO maior que 79 anos é necessário o adicional ZELO MAIOR 79 ANOS.');
        }

        return this;
    }

    padrastoComAdicionalMaiorIgual65() {
        if (validatorPadrastoMaiorIgual65(this.valoresForm, this.dependentes)) {
            this.arrayMsgsErro.push('Caso já exista um dependente do tipo PAI ou PADRASTO sem adicional  e queira adicionar um dependente do tipo PADRASTO acima de 65 anos é necessário o adicional ZELO MAIOR 65 ANOS.');
        }

        return this;
    }

    parentescosComAdicionalElegivelAte64() {
        if (validatorDependentesQuePodemSemOuComAdicionalAte64(this.valoresForm, this.dependentes)) {
            this.arrayMsgsErro.push('Para dependentes do tipo Ex-conjuge, Madrasta e/ou Padastro até 64 anos, e que não possuam um dependente de grau equivalente sem valor adicional, é permitido SEM VALOR ADICIONAL ou ZELO ATÉ 64.');
        }

        return this;
    }

    parentescosComAdicionalElegivelMaior79() {
        if (validatorDependentesQuePodemSemOuComAdicionalMaior79(this.valoresForm, this.dependentes)) {
            this.arrayMsgsErro.push('Para dependentes do tipo Ex-conjuge, Madrasta e/ou Padastro maior que 79 anos, e que não possuam um dependente de grau equivalente sem valor adicional, é permitido SEM VALOR ADICIONAL ou ZELO MAIOR 79.');
        }

        return this;
    }

    parentescosComAdicionalElegivelAte65() {
        if (validatorDependentesQuePodemSemOuComAdicionalMaiorIgual65(this.valoresForm, this.dependentes)) {
            this.arrayMsgsErro.push('Para dependentes do tipo Ex-conjuge, Madrasta e/ou Padastro acima de 65 anos, e que não possuam um dependente de grau equivalente sem valor adicional, é permitido SEM VALOR ADICIONAL ou ZELO MAIOR 65 ANOS.');
        }

        return this;
    }

    parentescoEmDuplicidade() {
        if (validatorParentescoEmDuplicidadeCadastro(this.valoresForm, this.dependentes)) {
            this.arrayMsgsErro = [`${retornaLabelDoValorParentesco(this.parentesco)}`];
        }

        return this;
    }

    excecaoPetPorLocalidade() {
        if (verificarExcecaoPetPorLocalidade(this.valoresForm.Categoria.trim(), this.valoresForm.Parentesco.trim())) {
            this.arrayMsgsErro = [];
        }

        return this;
    }

    permitirDependentePetSomenteComAdicionalPet() {
        if (this.valoresForm.Parentesco.trim() === 'PET' && !categoriasPet.includes(this.valoresForm.Categoria.trim())) {
            this.arrayMsgsErro.push('Somente é permitido dependente PET que tenha como adicional referente ao PET');
        }

        return this;
    }

    limitarQuantidadePet() {
        const numeroDependentesPet = this.dependentes.filter(dependente => dependente['GrauParentesco.Grau'].trim() === 'PET').length;

        if (numeroDependentesPet >= this.maximoDependentesPet && this.valoresForm.Parentesco && this.valoresForm.Parentesco.trim() === 'PET') {
            this.arrayMsgsErro.push(`Só é permitido um dependente do tipo ${this.valoresForm.Parentesco}.`);
        }

        return this;
    }
}
